import { put, takeEvery } from 'redux-saga/effects'
import { types as modalTypes } from '../ducks/modal'
import { openDialog } from "redux-dialog";
import { isTextEmpty } from 'iotera-base/text';

const DEFAULT_UID = "0";

function* openModal(action) {
    const payload = action.payload;
    let uid = DEFAULT_UID;
    if (!isTextEmpty(payload)) {
        uid = payload
    }
    yield put(openDialog(uid, payload));
}

function* closeModal(action) {
    const payload = action.payload;
}

const modalSaga = [
    takeEvery(modalTypes.MODAL_SINGLE_OPEN, openModal),
    takeEvery(modalTypes.MODAL_SINGLE_CLOSE, closeModal)
]

export default modalSaga;